module.exports = __webpack_public_path__ + "img/eclpsr-ipad.20535ed0.jpg";